import React from "react";
import { CheckCircle, XCircle } from "lucide-react";
import { LESSON_STATUS } from "../../config/constants";

/**
 * StatusToggle Component
 * Reusable component for approving/unapproving items.
 *
 * @param {string} status - Current status of the item (Pending, Approved, etc)
 * @param {boolean} canEdit - Whether the current user has permission to toggle
 * @param {function} onApprove - Function to call when Approve is clicked
 * @param {function} onUnapprove - Function to call when Unapprove is clicked
 */
const StatusToggle = ({ status, canEdit, onApprove, onUnapprove }) => {
  const currentStatus = status || LESSON_STATUS.PENDING;
  const isApproved = currentStatus === LESSON_STATUS.APPROVED;

  return (
    <div className="flex items-center justify-center gap-2">
      <span
        className={`px-2 py-1 rounded text-xs font-medium ${
          isApproved
            ? "bg-green-100 text-green-800"
            : "bg-yellow-100 text-yellow-800"
        }`}
      >
        {currentStatus}
      </span>
      
      {canEdit && (
        isApproved ? (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onUnapprove && onUnapprove();
            }}
            title="Unapprove Lesson"
          >
            <XCircle size={16} className="text-yellow-700 hover:scale-110 transition-all" />
          </button>
        ) : (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onApprove && onApprove();
            }}
            className="p-1 rounded"
            title="Approve Lesson"
          >
            <CheckCircle size={16} className="text-green-700 hover:scale-110 transition-all" />
          </button>
        )
      )}
    </div>
  );
};

export default StatusToggle;
